module.exports = __webpack_public_path__ + "img/img15.9dafbad4.png";